import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failureaddyearGroup, successaddyearGroup } from "./AddyearGroupSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { IYearGroup } from "../../../Pages/Year group/IyearGroup";

import {
  failuredeleteyearGroup,
  successdeleteyearGroup,
} from "./DeleteyearGroupSlice";
import {
  failurelistyearGroup,
  successlistyearGroup,
} from "./ListyearGroupSlice";
import {
  failureEdityearGroup,
  successEdityearGroup,
} from "./EdityearGroupSlice";

// list
const ListyearGroupApi = () => {
  return api.get("/api/category/year-group");
};

export function* ListyearGroupCall() {
  try {
    const response: AxiosResponse = yield call(ListyearGroupApi);
    yield put(successlistyearGroup(response.data));
  } catch (error) {
    yield put(failurelistyearGroup(error));
  }
}

// add
const AddyearGroupApi = (action: PayloadAction<IYearGroup>) => {
  console.log("actionnn :-- ", action.payload);

  return api.post("/api/category/yeargroup/add", action.payload);
};

export function* AddyearGroupCall(action: PayloadAction<IYearGroup>) {
  try {
    console.log("AddyearGroupCall initiated...");
    const response: AxiosResponse = yield call(AddyearGroupApi, action);
    console.log("AddyearGroupCall response:", response.data);
    yield put(successaddyearGroup(response.data));
  } catch (error) {
    console.error("AddyearGroupCall error:", error);
    yield put(failureaddyearGroup(error));
  }
}

// edit
const EdityearGroupApi = (action: PayloadAction<IYearGroup>) => {
  return api.put("/api/category/yeargrope/update", action.payload, {
    params: { id: action.payload.id },
  });
};

export function* EdityearGroupCall(action: PayloadAction<IYearGroup>) {
  try {
    const response: AxiosResponse = yield call(EdityearGroupApi, action);
    yield put(successEdityearGroup(response.data));
  } catch (error) {
    yield put(failureEdityearGroup(error));
  }
}

// delete
const DeleteyearGroupApi = (action: PayloadAction<number>) => {
  return api.delete("/api/category/year-group/delete", {
    params: { id: action.payload },
  });
};

export function* DeleteyearGroupCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteyearGroupApi, action);
    yield put(successdeleteyearGroup(response.data));
  } catch (error) {
    yield put(failuredeleteyearGroup(error));
  }
}
